import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { getType, exportExcelMoeHold, exportExcelAatcReview } from "../../actions/studensts";
import UNAUTHORIZED from "../UNAUTHORIZED";
import StudentList from "../StudentList";
import { excelMoe, excelAct1MoePending, excelAct2MoePending } from "../exportToExcel";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";

export default function Moe() {
  const dispatch = useDispatch();
  const location = useLocation();
  const studentType = useLocation().pathname.split("/")[3];
  const { students } = useSelector((state) => state.students);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(false);
  const [hasSearched, setHasSearched] = useState(false);
  const count = useSelector((state) => state.students.count);
  const { role, username } = JSON.parse(localStorage.getItem("profile")).value[0];

  useEffect(() => {
    dispatch({ type: "CLEAR" });
    if (!hasSearched) return;
    const state = convertType(studentType);
    const timeOutId = setTimeout(
      () => dispatch(getType("moe", state, search)),
      500
    );
    return () => clearTimeout(timeOutId);
  }, [location, search, dispatch, studentType, hasSearched]);

  useEffect(() => {
    setHasSearched(false);
  }, [location]);

  useEffect(() => {
    if (students) {
      setLoading(false);
    } else {
      setLoading(true);
    }
  }, [students]);

  const handleExportMoeHold = async () => {
    try {
      const { data } = await exportExcelMoeHold();
      const students = data.data;

      const workbook = new ExcelJS.Workbook();
      workbook.creator = "AATC System";
      workbook.created = new Date();
      const sheet = workbook.addWorksheet("MOE Hold Report");

      sheet.mergeCells("A1:H1");
      const titleCell = sheet.getCell("A1");
      titleCell.value = "MOE Hold Students Report";
      titleCell.font = { name: "Arial", size: 16, bold: true, color: { argb: "FFFFFFFF" } };
      titleCell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FF1F4E79" } };
      titleCell.alignment = { horizontal: "center", vertical: "middle" };
      sheet.getRow(1).height = 35;

      sheet.mergeCells("A2:H2");
      const countCell = sheet.getCell("A2");
      countCell.value = `Total Students: ${students.length}`;
      countCell.font = { name: "Arial", size: 13, bold: true, color: { argb: "FF1F4E79" } };
      countCell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FFD6E4F0" } };
      countCell.alignment = { horizontal: "center", vertical: "middle" };
      sheet.getRow(2).height = 28;

      sheet.getRow(3).height = 8;

      const headers = [
        "National ID", "Passport Number", "Full Name", "Phone Number",
        "Reason", "Comment", "MOE Hold Date", "Commented By",
      ];
      const headerRow = sheet.getRow(4);
      headerRow.values = headers;
      headerRow.height = 26;
      headerRow.eachCell((cell) => {
        cell.font = { name: "Arial", size: 11, bold: true, color: { argb: "FFFFFFFF" } };
        cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FF2E75B6" } };
        cell.alignment = { horizontal: "center", vertical: "middle", wrapText: true };
        cell.border = {
          top: { style: "thin", color: { argb: "FF1F4E79" } },
          bottom: { style: "thin", color: { argb: "FF1F4E79" } },
          left: { style: "thin", color: { argb: "FF1F4E79" } },
          right: { style: "thin", color: { argb: "FF1F4E79" } },
        };
      });

      students.forEach((s, idx) => {
        const row = sheet.getRow(5 + idx);
        row.values = [
          s["National ID"], s["Passport Number"], s["Full Name"], s["Phone Number"],
          s["Reason"], s["Comment"], s["MOE Hold Date"], s["Commented By"],
        ];
        const isEven = idx % 2 === 0;
        row.eachCell((cell) => {
          cell.font = { name: "Arial", size: 10 };
          cell.alignment = { horizontal: "center", vertical: "middle", wrapText: true };
          cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: isEven ? "FFF2F7FB" : "FFFFFFFF" } };
          cell.border = {
            top: { style: "thin", color: { argb: "FFB4C6E7" } },
            bottom: { style: "thin", color: { argb: "FFB4C6E7" } },
            left: { style: "thin", color: { argb: "FFB4C6E7" } },
            right: { style: "thin", color: { argb: "FFB4C6E7" } },
          };
        });
      });

      sheet.columns = [
        { width: 20 }, { width: 20 }, { width: 30 }, { width: 18 },
        { width: 28 }, { width: 35 }, { width: 22 }, { width: 22 },
      ];

      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      saveAs(blob, "moe_hold_report.xlsx");
    } catch (error) {
      console.error("Export to Excel failed:", error);
    }
  };

  const handleExportAatcReview = async () => {
    try {
      const { data } = await exportExcelAatcReview();
      const students = data.data;

      const workbook = new ExcelJS.Workbook();
      workbook.creator = "AATC System";
      workbook.created = new Date();
      const sheet = workbook.addWorksheet("AATC Review Report");

      const COLS = 6;
      const colRange = `A1:F1`;

      sheet.mergeCells(colRange);
      const titleCell = sheet.getCell("A1");
      titleCell.value = "AATC Review Students Report";
      titleCell.font = { name: "Arial", size: 16, bold: true, color: { argb: "FFFFFFFF" } };
      titleCell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FF1F4E79" } };
      titleCell.alignment = { horizontal: "center", vertical: "middle" };
      sheet.getRow(1).height = 35;

      sheet.mergeCells("A2:F2");
      const countCell = sheet.getCell("A2");
      countCell.value = `Total Students: ${students.length}`;
      countCell.font = { name: "Arial", size: 13, bold: true, color: { argb: "FF1F4E79" } };
      countCell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FFD6E4F0" } };
      countCell.alignment = { horizontal: "center", vertical: "middle" };
      sheet.getRow(2).height = 28;

      sheet.getRow(3).height = 8;

      const headers = [
        "National ID", "Full Name", "Phone Number",
        "Comment", "Stage Date", "Transferred By",
      ];
      const headerRow = sheet.getRow(4);
      headerRow.values = headers;
      headerRow.height = 26;
      headerRow.eachCell((cell) => {
        cell.font = { name: "Arial", size: 11, bold: true, color: { argb: "FFFFFFFF" } };
        cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FF2E75B6" } };
        cell.alignment = { horizontal: "center", vertical: "middle", wrapText: true };
        cell.border = {
          top: { style: "thin", color: { argb: "FF1F4E79" } },
          bottom: { style: "thin", color: { argb: "FF1F4E79" } },
          left: { style: "thin", color: { argb: "FF1F4E79" } },
          right: { style: "thin", color: { argb: "FF1F4E79" } },
        };
      });

      students.forEach((s, idx) => {
        const row = sheet.getRow(5 + idx);
        row.values = [
          s["National ID"], s["Full Name"], s["Phone Number"],
          s["Comment"], s["Stage Date"], s["Transferred By"],
        ];
        const isEven = idx % 2 === 0;
        row.eachCell((cell) => {
          cell.font = { name: "Arial", size: 10 };
          cell.alignment = { horizontal: "center", vertical: "middle", wrapText: true };
          cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: isEven ? "FFF2F7FB" : "FFFFFFFF" } };
          cell.border = {
            top: { style: "thin", color: { argb: "FFB4C6E7" } },
            bottom: { style: "thin", color: { argb: "FFB4C6E7" } },
            left: { style: "thin", color: { argb: "FFB4C6E7" } },
            right: { style: "thin", color: { argb: "FFB4C6E7" } },
          };
        });
      });

      sheet.columns = [
        { width: 20 }, { width: 30 }, { width: 18 },
        { width: 35 }, { width: 22 }, { width: 22 },
      ];

      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      saveAs(blob, "aatc_review_report.xlsx");
    } catch (error) {
      console.error("Export to Excel failed:", error);
    }
  };

  return (
    <div>
      {role !== "user" && role !== "admin" ? (
        <UNAUTHORIZED />
      ) : (
        <div>
          <div className="flex flex-wrap pt-0 pl-6 pb-10 justify-between">
            <h1 className="text-2xl text-white">
              {studentType === "new"
                ? "Sending to MOE"
                : studentType === "moe_pending"
                ? "Moe Pending"
                : studentType === "moe_validation"
                ? "Moe Validation"
                : studentType === "moe_hold"
                ? "MOE Hold"
                : studentType === "aatc_review"
                ? "AATC Review"
                : ""}
            </h1>
            {studentType === "new" &&
              (username === "asmaa" ||
                username === "officer" ||
                username === "abdelrhman"||
                username === "alaa") && (
                <div className="pr-32">
                  <button
                    type="button"
                    className="text-white bg-green-900 hover:bg-green-800 p-2 
                        focus:ring-4 focus:ring-green-400 font-medium rounded-lg text-sm text-center cursor-pointer"
                    onClick={excelMoe}
                  >
                    Export to Excel
                  </button>
                </div>
              )}
            {studentType === "moe_pending" &&
              (username === "abdelrhman" ||
                username === "alaa" ||
                username === "asmaa" ||
                username === "admin" ||
                username === "acountant-1") && (
                <div className="flex pr-32">
                  <div className="px-2">
                    <button
                      type="button"
                      className="text-white bg-green-900 hover:bg-green-800 p-2 
                          focus:ring-4 focus:ring-green-400 font-medium rounded-lg text-sm text-center cursor-pointer"
                      onClick={excelAct1MoePending}
                    >
                      Export Act1 Students
                    </button>
                  </div>
                  <div className="px-2">
                    <button
                      type="button"
                      className="text-white bg-green-900 hover:bg-green-800 p-2 
                          focus:ring-4 focus:ring-green-400 font-medium rounded-lg text-sm text-center cursor-pointer"
                      onClick={excelAct2MoePending}
                    >
                      Export Act2 Students
                    </button>
                  </div>
                </div>
              )}
            {studentType === "moe_hold" && (
              <div className="pr-32">
                <button
                  type="button"
                  className="text-white bg-blue-600 hover:bg-blue-700 p-2 
                      focus:ring-4 focus:ring-blue-400 font-medium rounded-lg text-sm text-center cursor-pointer"
                  onClick={handleExportMoeHold}
                >
                  Export to Excel
                </button>
              </div>
            )}
            {studentType === "aatc_review" && (
              <div className="pr-32">
                <button
                  type="button"
                  className="text-white bg-blue-600 hover:bg-blue-700 p-2 
                      focus:ring-4 focus:ring-blue-400 font-medium rounded-lg text-sm text-center cursor-pointer"
                  onClick={handleExportAatcReview}
                >
                  Export to Excel
                </button>
              </div>
            )}
          </div>
          <div className="flex justify-center">
            <div
              className="lg:w-3/5 md:w-3/4 w-full min-h-screen border shadow
                flex flex-col bg-white p-6 rounded-lg"
            >
              <StudentList
                setSearch={(val) => {
                  setSearch(val);
                  setHasSearched(true);
                }}
                students={students}
                search={search}
                loading={loading}
                count={count}
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

function convertType(studentType) {
  switch (studentType) {
    case "moe_validation":
      return "moe_validation";
    case "new":
      return "moe";
    case "moe_pending":
      return "moe_pending";
    case "moe_hold":
      return "moe_hold";
    case "aatc_review":
      return "aatc_review";
    default:
      return "moe_validation";
  }
}
